import React, {useState, useEffect, useContext} from 'react';
import {Card, CardHeader, CardBody, Input, Table} from 'reactstrap';
import {getCombinedUsers, getAllProducts} from 'utils/api';
import Loader from 'components/Loader';
import moment from 'moment';
import {ErrorContext} from 'contexts/ErrorContext';
import sortAlphabetically from 'helpers/sortAlphabetically';
import PaginationWrapper from 'components/PaginationWrapper';
import CombinedUserListItem from './CombinedUserListItem';
import SortableTableHeader from 'components/SortableTableHeader';
import {sortByValue} from 'helpers/sortByValue';

//import './style.scss';


const CombinedUsers = () => {
    const {handleErrors} = useContext(ErrorContext);

    const [searchValue, setSearchValue] = useState('');
    const [fullUsersList, setFullUsersList] = useState(null);
    const [visibleList, setVisibleList] = useState(null);
    const [activeSortProperty, setActiveSortProperty] = useState('accountName');
    const [activeSortDirection, setActiveSortDirection] = useState('asc');
    const [fetchingData, setFetchingData] = useState(true);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [activeMobileSortSelection, setActiveMobileSortSelection] = useState('accountName-asc');
    const [productsList, setProductsList] = useState([]);

    useEffect(() => {
        getUsersList();
        fetchProductsList();
    }, []);

    useEffect(() => {
        if(fullUsersList && visibleList) {
            applyFilters(true, fullUsersList);
        }
    }, [activeSortProperty, activeSortDirection, searchValue]);

    const applyFilters = (resetPage, list) => {
        let newArr = sortByValue(list, activeSortProperty, activeSortDirection);
        if(searchValue && searchValue.length > 0) {
            let arrFilteredBySearchValue = newArr.filter(item => {
                return item.name.toLowerCase().includes(searchValue.toLowerCase()) || item.email.toLowerCase().includes(searchValue.toLowerCase()) || item.accountName.toLowerCase().includes(searchValue.toLowerCase())
            });
            setVisibleList(arrFilteredBySearchValue);
            resetPage && setCurrentPageNumber(1);
        } else {
            setVisibleList(newArr);
            resetPage && setCurrentPageNumber(1);
        }
    }

    const getUsersList = async(refresh) => {
        try {
            !fetchingData && !refresh && setFetchingData(true);
            let usersData = await getCombinedUsers();
            usersData.content.result.forEach(item => {
                if(item.name === null) item.name = '';
            });
            let initialList = sortAlphabetically(usersData.content.result, 'accountName');
            setFullUsersList(initialList);
            if(!refresh) {
                setVisibleList(initialList);
            }
            refresh && applyFilters(!refresh, initialList);
            setFetchingData(false);
        } catch(err) {
            console.log(err);
            handleErrors(err);
            setFetchingData(false);
        }
    };

    const fetchProductsList = async() => {
        try {
            // !fetchingData && !refresh && setFetchingData(true);
            let productsData = await getAllProducts();
            setProductsList(productsData.content.result);
            // productsData.content.result.forEach(item => {
            //     if(item.name === null) item.name = '';
            // });
            // let initialList = sortAlphabetically(productsData.content.result, 'name');
            // setFetchingData(false);
        } catch(err) {
            console.log(err);
            handleErrors();
        }
    };


    const handlePaginationClick = (pageNumber) => {
        setCurrentPageNumber(pageNumber.selected + 1);
    };

    const handleSortSelect = (sortValue) => {
        if(activeSortProperty === sortValue) {
            setActiveSortDirection(activeSortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setActiveSortProperty(sortValue);
            setActiveSortDirection('asc');
        }
    };

    const handleMobileSortSelect = (sortSelection) => {
        let splitArr = sortSelection.split('-')
        if(splitArr.length === 2) {
            setActiveSortProperty(splitArr[0])
            setActiveSortDirection(splitArr[1])
        }
        setActiveMobileSortSelection(sortSelection)
    };

    return (
        <div className="wrapper d-flex align-items-center mt-3 flex-column">
            <Card className="w-100">

                <CardHeader>
                    <h1 className="mb-0" style={{textAlign: 'center'}}>Combined Users List</h1>
                </CardHeader>
                {fetchingData ? (
                    <div style={{padding: '3rem 2rem'}}>
                        <Loader small text="Fetching user data"/>
                    </div>
                ) : (
                    <React.Fragment>
                        <CardBody>
                            <div className="feeds-container_input">
                                {fullUsersList !== null && fullUsersList.length > 0 && (
                                    <div className="feeds-container-wrapper">
                                        <Input
                                            style={{height: '35px'}}
                                            onChange={(e) => setSearchValue(e.target.value)}
                                            value={searchValue}
                                            placeholder="Search by name, email, or organization"
                                            type="text"
                                            className="searchInput"
                                        />
                                        {!searchValue ? (
                                            <i
                                                style={{
                                                    position: 'absolute',
                                                    top: '28%',
                                                    bottom: '10.5px',
                                                    right: '11px',
                                                }}
                                                className="fa fa-search search-container_icon"
                                            />
                                        ) : (
                                            <i
                                                style={{
                                                    cursor: 'pointer',
                                                    position: 'absolute',
                                                    top: '28%',
                                                    bottom: '10.5px',
                                                    right: '11px',
                                                }}
                                                onClick={() => setSearchValue('')}
                                                className="fa fa-times-circle search-container_icon"
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                            {fullUsersList && fullUsersList.length > 0 && (
                                <div className="feeds_sortBy">
                                    <span>Sort by</span>
                                    <Input onChange={(e) => handleMobileSortSelect(e.target.value)} type="select"
                                           value={activeMobileSortSelection}>
                                        <option value="accountName-asc">Organization (A to Z)</option>
                                        <option value="accountName-desc">Organization (Z to A)</option>
                                        <option value="name-asc">Name (A to Z)</option>
                                        <option value="name-desc">Name (Z to A)</option>
                                        <option value="email-asc">Email (A to Z)</option>
                                        <option value="email-desc">Email (Z to A)</option>
                                        <option value="productName-asc">Product (A to Z)</option>
                                        <option value="productName-desc">Product (Z to A)</option>
                                        <option value="isAdministrator-asc">User Type (A to Z)</option>
                                        <option value="isAdministrator-desc">UserType (Z to A)</option>
                                        <option value="enabled-desc">Confirmed ('Yes' first)</option>
                                        <option value="enabled-asc">Confirmed ('No' first)</option>
                                        <option value="createdAt-desc">Created At (New first)</option>
                                        <option value="createdAt-asc">Created At (Old first)</option>
                                        <option value="lastLogin-desc">Last Login (New first)</option>
                                        <option value="lastLogin-asc">Last Login (Old first)</option>
                                        {/*<option value="fetchesAlertsCount">Fetches Alerts (1 to 9)</option>*/}
                                        {/*<option value="fetchesAlertsCountDescending">Fetches Alerts (9 to 1)</option>*/}
                                        <option value="searchCount-asc">Searches Alerts (Ascending)</option>
                                        <option value="searchCount-desc">Searches Alerts (Descending)</option>
                                    </Input>
                                </div>
                            )}
                            <div className="table mt-3">
                                {fullUsersList && fullUsersList.length > 0 ? (
                                    <Table style={{color: '#314784'}} responsive>
                                        <thead className="hidden">
                                        <tr>
                                            <SortableTableHeader
                                                name="Organization"
                                                value="accountName"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('accountName')}
                                            />
                                            <SortableTableHeader
                                                name="Name"
                                                value="name"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('name')}
                                            />
                                            <SortableTableHeader
                                                name="Email"
                                                value="email"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('email')}
                                            />
                                            <SortableTableHeader
                                                name="Product"
                                                value="productName"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('productName')}
                                            />
                                            <SortableTableHeader
                                                name="User Type"
                                                value="isAdministrator"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('isAdministrator')}
                                            />
                                            <SortableTableHeader
                                                name="Confirmed"
                                                value="enabled"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('enabled')}
                                            />
                                            <SortableTableHeader
                                                name="Created At"
                                                value="createdAt"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('createdAt')}
                                            />
                                            <SortableTableHeader
                                                name="Last Login"
                                                value="lastLogin"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('lastLogin')}
                                            />
                                            {/*<th onClick={() => handleSortTypeChange('fetchesAlertsCount')}*/}
                                            {/*    style={{cursor: 'pointer', minWidth: '160px'}}>*/}
                                            {/*    <div style={{border: 'none'}} className="d-flex align-items-center">*/}
                                            {/*        <span className="mr-1">Fetches Alerts</span>*/}
                                            {/*        <i className={*/}
                                            {/*            activeSort === 'fetchesAlertsCount'*/}
                                            {/*                ? 'fas fa-sort-numeric-down'*/}
                                            {/*                : activeSort === 'fetchesAlertsCountDescending'*/}
                                            {/*                ? 'fas fa-sort-numeric-up'*/}
                                            {/*                : 'fas fa-sort'*/}
                                            {/*        }/>*/}
                                            {/*    </div>*/}
                                            {/*</th>*/}
                                            <SortableTableHeader
                                                name="Searches Alerts"
                                                value="searchCount"
                                                activeSortValue={activeSortProperty}
                                                activeSortDirection={activeSortDirection}
                                                handleSelect={() => handleSortSelect('searchCount')}
                                            />
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {visibleList && visibleList.length > 0 ?
                                            visibleList.slice((currentPageNumber - 1) * 50, currentPageNumber * 50).map((item) => (
                                                <CombinedUserListItem
                                                    item={item}
                                                    handleErrors={handleErrors}
                                                    refreshList={getUsersList}
                                                    productsList={productsList}
                                                />
                                            ))
                                            :
                                            <tr>
                                                <td className="mt-5">No matching results</td>
                                            </tr>
                                        }
                                        </tbody>
                                    </Table>
                                ) : (
                                    <p className="mt-5">No users found</p>
                                )}
                            </div>
                            {visibleList && visibleList.length > 50 && (
                                <PaginationWrapper
                                    totalPages={Math.ceil(visibleList.length / 50)}
                                    handlePageClick={handlePaginationClick}
                                />
                            )}
                        </CardBody>
                    </React.Fragment>
                )}
            </Card>
        </div>
    );
};

export default CombinedUsers;